import angular from 'angular';

import usersModuleConfig from './users.config';

import appAuthFactory from './services/appAuth.factory';
import referrerService from './services/referrer.service';
import userService from './services/user.service';

import paymentPaypalController from './controllers/payment-paypal.ctrl';
import paymentStripeController from './controllers/payment-stripe.ctrl';
import loginController from './controllers/login.ctrl';
import registerController from './controllers/register.ctrl';

import causeAssociatedDirective from './directives/causeAssociated';
import emailVerifyPopupDirective from './directives/emailVerifyPopup';
import loginFormHelperDirective from './directives/loginFormHelper';
import navbarDirective from './directives/navbar';
import causeSelectorDirective from './directives/causeSelector';
import loadingPopupDirective from './directives/loadingPopup';
import loginDirective from './directives/login';

import joinStepsComponent from './components/joinSteps';
import renewalStepsComponent from './components/renewalSteps';
import paypalformComponent from './components/paypalform';
import stripeformComponent from './components/stripeform';

const usersModule = angular.module('com.module.users', []);

usersModule.config(usersModuleConfig);

usersModule.factory('AppAuthFactory', appAuthFactory);
usersModule.service('ReferrerService', referrerService);
usersModule.service('UserService', userService);

usersModule.controller('PaymentPaypalCtrl', paymentPaypalController);
usersModule.controller('PaymentStripeCtrl', paymentStripeController);
usersModule.controller('LoginCtrl', loginController);
usersModule.controller('RegisterCtrl', registerController);

usersModule.directive('causeAssociated', causeAssociatedDirective);
usersModule.directive('emailVerifyPopup', emailVerifyPopupDirective);
usersModule.directive('loginFormHelper', loginFormHelperDirective);
usersModule.directive('navbar', navbarDirective);
usersModule.directive('causeSelector', causeSelectorDirective);
usersModule.directive('loadingPopup', loadingPopupDirective);
usersModule.directive('login', loginDirective);

usersModule.component('joinSteps', joinStepsComponent);
usersModule.component('renewalSteps', renewalStepsComponent);
usersModule.component('paypalform', paypalformComponent);
usersModule.component('stripeform', stripeformComponent);

export default usersModule;



// WEBPACK FOOTER //
// ./js/containers/users/index.js